import bookingExtrasService from "@/services/bookingExtrasService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await bookingExtrasService.create(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Buchungsextra wurde erfolgreich angelegt.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextra konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await bookingExtrasService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextras konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await bookingExtrasService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextra konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await bookingExtrasService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextra konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await bookingExtrasService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Buchungsextra wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextra konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
